const FULL_GIT_SHA_PATTERN = /^[0-9a-f]{40}$/i;

export type DeploymentVersionComparison = {
  status: "same" | "different" | "unknown";
  clientRelease: string | null;
  servedRelease: string | null;
};

export function normalizeDeploymentVersion(value: string): string | null {
  if (value === "local") {
    return value;
  }
  if (!FULL_GIT_SHA_PATTERN.test(value)) {
    return null;
  }
  return value.toLowerCase();
}

export function compareDeploymentVersions(
  clientValue: string,
  servedValue: string
): DeploymentVersionComparison {
  const clientRelease = normalizeDeploymentVersion(clientValue);
  const servedRelease = normalizeDeploymentVersion(servedValue);

  if (
    !clientRelease ||
    !servedRelease ||
    (clientRelease === "local") !== (servedRelease === "local")
  ) {
    return {
      status: "unknown",
      clientRelease,
      servedRelease,
    };
  }

  return {
    status: clientRelease === servedRelease ? "same" : "different",
    clientRelease,
    servedRelease,
  };
}
